import { t } from '@/features/i18n/utils';
import { noop } from '@tanstack/react-query';
import { useWorkspace } from '@/features/workspaces/helpers';
import { getDefaultStore } from 'jotai';
import { tasksQuery } from '@/features/tasks/queries';
import { tasksDisplayAtom, tasksFilterAtom } from '@/features/tasks/store';
import { taskListFilters } from '@/features/tasks/utils';
import { createFileRoute } from '@tanstack/react-router';
import { WorkspaceTypeIcon } from '@/features/workspaces/components/workspace-type-icon';
import { Breadcrumb, BreadcrumbLink, BreadcrumbPage } from '@/ui/components/breadcrumb';
import { Header, HeaderChatButton, HeaderBackButton } from '@/ui/components/header';
import { Icon } from '@/ui/components/icon';
import { SquareCheckBigIcon } from '@hugeicons-pro/core-stroke-rounded';
import { TasksPage } from '@/features/tasks/components/tasks-page';

export const Route = createFileRoute(
  '/_authed/project/$projectId/workspaces/$workspaceId/_layout/tasks',
)({
  component: RouteComponent,
  loader: ({ context, params }) => {
    const store = getDefaultStore();
    const filters = taskListFilters({
      user: context.auth.user,
      projectId: params.projectId,
      workspaceId: params.workspaceId,
      filter: store.get(tasksFilterAtom),
      display: store.get(tasksDisplayAtom),
      search: '',
    });
    if (filters) context.queryClient.infiniteQuery(tasksQuery(filters)).catch(noop);
  },
});

function RouteComponent() {
  const { projectId, workspaceId } = Route.useParams();
  const workspace = useWorkspace();

  return (
    <>
      <Header>
        <HeaderBackButton />
        <Breadcrumb>
          <BreadcrumbLink
            to="/project/$projectId/workspaces/$workspaceId"
            params={{ projectId, workspaceId }}
          >
            <WorkspaceTypeIcon type={workspace.type} />
            <span className="line-clamp-1">{workspace.name}</span>
          </BreadcrumbLink>
          <BreadcrumbPage>
            <Icon icon={SquareCheckBigIcon} />
            {t({ en: 'Tasks', nb: 'Oppgaver' })}
          </BreadcrumbPage>
        </Breadcrumb>
        <HeaderChatButton />
      </Header>
      <TasksPage />
    </>
  );
}
